export default __webpack_public_path__ + "static/media/logo-colored.371ada55.png";